import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { PreWraper } from '@components/shared/wraper/PreWraper'

type Props = {
  id: number
  name: string
  imagePath: string
  shortIntroduction: string
}

export const LecturerProfileList = ({
  id,
  name,
  imagePath,
  shortIntroduction,
}: Props): JSX.Element => {
  return (
    <div className="flex flex-row items-center">
      <div className="w-[26.7vw] lg:w-[7.8vw] lg:hover:opacity-50">
        <a href={`/lecturers/${id}`}>
          <ImageWraper
            className="rounded-[100px]"
            src={imagePath}
            width={150}
            height={150}
          />
        </a>
      </div>
      <div className="mt-0 lg:mt-0 ml-[5.3vw] lg:ml-[2.3vw] w-[45vw] lg:w-[45.3vw]">
        <div className="font-bold text-[#333333]">{name}</div>
        <div className="three-line-limit">
          <PreWraper
            text={shortIntroduction}
            classes="text-[3.2vw] lg:text-[1.1vw] leading-[7.5vw] lg:leading-[2.2vw] text-[#333333]"
          />
        </div>
      </div>
    </div>
  )
}
